import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserCheck } from "@fortawesome/free-solid-svg-icons"

export const UserCheck = (props) => {
  return <FontAwesomeIcon faIcon={faUserCheck} {...props} />
}
